import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=1fd99561&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"
import style0 from "./Assistant.vue?vue&type=style&index=0&id=1fd99561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd99561",
  null
  
)

export default component.exports